import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';
import { PromptService } from 'src/app/services/prompt.service';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class DefaultComponent implements OnInit, OnDestroy {
  @ViewChild('communityNavEl', { static: false }) communityNavEl: ElementRef;
  subscriptions: Subscription = new Subscription();
  user;
  menuToggled = false;
  communityNav = {
    toggled: false,
    active: false,
    listItems: [
      { routerLink: 'members', label: 'Members' },
      { routerLink: 'institutions', label: 'Institutions' },
      { routerLink: 'resources', label: 'Resources' },
      { routerLink: 'events', label: 'Events' },
      { routerLink: 'jobs', label: 'Job Board' },
      { routerLink: 'about', label: 'About Us' },
    ],
  };
  currentYear = new Date().getFullYear();
  communityBannerDismissed = false;

  constructor(
    private userService: UserService,
    private toastService: ToastService,
    private promptService: PromptService,
    private _eref: ElementRef,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.route.snapshot.firstChild.data['group'] === "community") {
          this.communityNav.active = true;
        } else {
          this.communityNav.active = false;
        }
      });
  }

  ngOnInit() {
    if ('communityBannerDismissed' in window.localStorage && window.localStorage.communityBannerDismissed === 'true') {
      this.communityBannerDismissed = true;
    } else {
      const bannerStyles = document.createElement('style');
      bannerStyles.id = 'banner-styles';
      bannerStyles.innerHTML = `
        body {
          padding-top: 170px;
        }
      `;
      document.querySelector('body').appendChild(bannerStyles);
    }
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.user = u;
          if (this.user.banned) {
            this.router.navigateByUrl('/m/user-deleted');
            this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe(event => { this.router.navigateByUrl('/m/user-deleted'); });
          }
        } else {
          this.user = null;
        }
      })
    );
  }

  toggleDropdown(obj) {
    obj.toggled = !obj.toggled;
  }

  toggleMenu() {
    this.menuToggled = !this.menuToggled;
  }

  onClick(event) {
    if (!this.communityNavEl.nativeElement.contains(event.target)) {
      if (this.communityNav.toggled) {
        this.communityNav.toggled = false;
      }
    }
  }
  dismissCommunityBanner(redirect) {
    if (document.getElementById('banner-styles')) {
      document.getElementById('banner-styles').remove();
    }
    window.localStorage.communityBannerDismissed = true;
    this.communityBannerDismissed = true;
    if (redirect) {
      this.router.navigateByUrl(redirect);
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
